import get_tiles_configuration from "@/data/tiles";
import { get_user_profile } from "@/router";
import is_admin_user from "@/utils/auth_user";
import { default_mining_menu_item } from "@/data/mining";
import { get_active_sector, set_active_sector, clear_active_sector } from "@/utils/active_sector";

const active_property_storage_key = "bolide_active_property_context";

export default {
  data() {
    return ({
      sidebar_tiles: [],
      sidebar_active_property: null,
      sidebar_active_item: "portfolio-comparisons",
      sidebar_sector: "property",
      sidebar_mining_item: default_mining_menu_item,
    });
  },

  computed: {
    sidebar_can_view_portfolio() {
      return is_admin_user(get_user_profile());
    },
  },

  created() {
    this.load_sidebar_context();
  },

  methods: {
    load_sidebar_context() {
      this.sidebar_tiles = get_tiles_configuration();
      const context = this.read_sidebar_property_context();
      this.sidebar_active_property = this.sidebar_tiles.find((tile) => {
        return String(tile.id) === String(context?.id)
          || String(tile.title) === String(context?.title);
      }) || null;
      this.sidebar_active_item = context?.menuItem || "portfolio-comparisons";

      const sector = get_active_sector();
      this.sidebar_sector = sector?.id === "mining" ? "mining" : "property";
      this.sidebar_mining_item = sector?.menuItem || default_mining_menu_item;
    },

    read_sidebar_property_context() {
      return JSON.parse(sessionStorage.getItem(active_property_storage_key) || "null");
    },

    open_sidebar_property(tile_id, menu_item = "operations-overview") {
      clear_active_sector();
      const tile = this.sidebar_tiles.find((item) => item.id === tile_id);
      if (tile) {
        sessionStorage.setItem(active_property_storage_key, JSON.stringify({
          id: tile.id,
          title: tile.title,
          menuItem: menu_item,
        }));
      }
      this.$router.push("/home");
    },

    open_sidebar_property_menu(data) {
      this.open_sidebar_property(data.propertyId, data.menuItem);
    },

    open_sidebar_portfolio() {
      clear_active_sector();
      sessionStorage.removeItem(active_property_storage_key);
      this.$router.push("/home");
    },

    open_sidebar_sector(sector) {
      if (sector.id === "mining") {
        this.open_sidebar_mining_menu(default_mining_menu_item);
        return;
      }

      this.open_sidebar_portfolio();
    },

    open_sidebar_mining_menu(menu_item) {
      set_active_sector("mining", menu_item);
      this.$router.push("/home");
    },
  },
};
